import Tab from '../Bootstrap/tab';

document.addEventListener('DOMContentLoaded', () => {
    openTabByHash(window.location.hash);
})

window.addEventListener('hashchange', () => {
    openTabByHash(window.location.hash);
})

window.addEventListener('popstate', event => {
    if (event.state !== null && event.state.hasOwnProperty('tabChange')) {
        openTabByHash(window.location.hash);
    }
})

document.addEventListener('shown.bs.tab', event => {
    const target = event.target as HTMLElement;
    if(target.getAttribute('href') !== window.location.hash) {
        history.pushState({tabChange: true}, '', target.getAttribute('href') || '');
    }
});

function openTabByHash(hash: string): void
{
    if (hash !== '') {
        let link = document.querySelector('[href="'+hash+'"]') as HTMLLinkElement|null;
        if (link?.matches('[data-bs-toggle="tab"]')) {
            Tab.getOrCreateInstance(link).show();
        }
    }
}
